// @ts-expect-error untyped module
import getCountryName from 'ui-addon-i18n/internal/utils/getCountryName';
import unescapedText from 'I18n/utils/unescapedText';
import { useMemo } from 'react';
import { useAppliedFilters } from './useAppliedFilters';
import { useGates } from '../../hooks/useGates';
import { useLocation } from 'react-router-dom';
import { Paths } from '../../constants/paths';
import { useSupportedListingOptions } from './useSupportedListingOptions';
import { usePartnerTierIconMap } from '../../utils/getPartnerTierContent';
export function useFilterTags() {
  const gates = useGates();
  const appliedFilters = useAppliedFilters();
  const location = useLocation();
  const supportedListingOptions = useSupportedListingOptions();
  const partnerTierIconMap = usePartnerTierIconMap();
  const filterTags = useMemo(() => {
    const tags = [];
    for (const appliedFilter of appliedFilters) {
      if (gates.solutionsSpringSpotlight && appliedFilter.field === 'PRODUCT_TYPE' && location.pathname === Paths.SEARCH_RESULTS) {
        continue;
      }

      // Special handling for language filters
      if (appliedFilter.field === 'APP_LANGUAGES' || appliedFilter.field === 'PROFILE_LANGUAGES') {
        tags.push(...appliedFilter.values.map(value => {
          var _ref, _appliedFilter$label;
          return {
            field: appliedFilter.field,
            text: unescapedText(`SharedI18nStrings.languageNames.${value}`),
            tooltip: (_ref = (_appliedFilter$label = appliedFilter.label) !== null && _appliedFilter$label !== void 0 ? _appliedFilter$label : appliedFilter.placeholder) !== null && _ref !== void 0 ? _ref : '',
            value
          };
        }));
        continue;
      }

      // Special handling for country filters
      if (appliedFilter.field === 'PROFILE_LOCATION_COUNTRY') {
        tags.push(...appliedFilter.values.map(value => {
          var _ref2, _appliedFilter$label2;
          return {
            field: appliedFilter.field,
            text: getCountryName(value),
            tooltip: (_ref2 = (_appliedFilter$label2 = appliedFilter.label) !== null && _appliedFilter$label2 !== void 0 ? _appliedFilter$label2 : appliedFilter.placeholder) !== null && _ref2 !== void 0 ? _ref2 : '',
            value
          };
        }));
        continue;
      }

      // Special handling for supported listings
      if (appliedFilter.field === 'PROFILE_SUPPORTED_LISTINGS') {
        appliedFilter.values.forEach(value => {
          var _ref3, _appliedFilter$label3;
          const matchingListing = supportedListingOptions.find(l => l.value === value);
          if (!matchingListing) return;
          tags.push({
            field: appliedFilter.field,
            text: matchingListing.text,
            tooltip: (_ref3 = (_appliedFilter$label3 = appliedFilter.label) !== null && _appliedFilter$label3 !== void 0 ? _appliedFilter$label3 : appliedFilter.placeholder) !== null && _ref3 !== void 0 ? _ref3 : '',
            value: matchingListing.value
          });
        });
        continue;
      }

      // Flatten the options if necessary
      const options = appliedFilter.options.length > 0 ? appliedFilter.options : appliedFilter.optionGroups.flatMap(group => group.options);

      // Toggle filters, such as Installable, Breeze, and Certified, have no options
      if (options.length === 0) {
        var _ref4, _appliedFilter$label4;
        tags.push({
          field: appliedFilter.field,
          text: (_ref4 = (_appliedFilter$label4 = appliedFilter.label) !== null && _appliedFilter$label4 !== void 0 ? _appliedFilter$label4 : appliedFilter.placeholder) !== null && _ref4 !== void 0 ? _ref4 : '',
          value: appliedFilter.values[0],
          // Don't show a tooltip for toggle filters, as they are self-explanatory
          tooltip: ''
        });
        continue;
      }
      for (const option of options) {
        if (appliedFilter.values.includes(option.value)) {
          var _ref5, _appliedFilter$label5;
          tags.push({
            field: appliedFilter.field,
            icon: appliedFilter.field === 'PROFILE_SOLUTIONS_PARTNER_TIER' ? partnerTierIconMap === null || partnerTierIconMap === void 0 ? void 0 : partnerTierIconMap[option.value] : undefined,
            text: option.text,
            tooltip: (_ref5 = (_appliedFilter$label5 = appliedFilter.label) !== null && _appliedFilter$label5 !== void 0 ? _appliedFilter$label5 : appliedFilter.placeholder) !== null && _ref5 !== void 0 ? _ref5 : '',
            value: option.value
          });
        }
      }
    }
    return tags;
  }, [appliedFilters, gates.solutionsSpringSpotlight, location.pathname, partnerTierIconMap, supportedListingOptions]);
  return filterTags;
}